import {
  useMutation,
  type UseMutationOptions,
  useQueryClient
} from "@tanstack/react-query";

import type { PostRetryFailedClaimIntegrationStepRequestDto } from "../../dtos/post-retry-failed-claim-integration-step-request-dto";
import type { PostRetryFailedIntegrationStepResponseDto } from "../../dtos/post-retry-failed-integration-step-response-dto";
import { OrderQueryKeys } from "../../generators/order-query-keys";
import { OrderService } from "../../services/order-service";

type UsePostRetryFailedClaimIntegrationStepMutationProps = {
  options?: UseMutationOptions<
    PostRetryFailedIntegrationStepResponseDto,
    unknown,
    PostRetryFailedClaimIntegrationStepRequestDto
  >;
};

export const usePostRetryFailedClaimIntegrationStepMutation = ({
  options
}: UsePostRetryFailedClaimIntegrationStepMutationProps = {}) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (payload) =>
      await OrderService.postRetryFailedClaimIntegrationStep({ payload }),
    ...options,
    onSuccess: async (...args) => {
      const [, variables] = args;

      await queryClient.invalidateQueries({
        queryKey: OrderQueryKeys.getClaimIntegrationStatus(variables.claimId)
          .queryKey
      });

      options?.onSuccess?.(...args);
    }
  });
};
